import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";
import {lineBlueHeavy} from "../const";

// matches FrmShape's default stroke, so the extension reads as part of the profiles.
const STROKE_WIDTH = 2;

// the outside faces of an angled mullion, run on past the two profiles until they meet
// in a point: one polyline from the left half's face end, through the meeting point, to
// the right half's face end. Drawn in the left half's frame; `anchor` is the local
// origin, so the owner links it to the point the coordinates are relative to.
export class MullionFaceExtension extends DrawFrmThing {
    anchor: FrmRefPoint;

    constructor(points: {x: number; y: number}[]) {
        super();

        this.anchor = new FrmRefPoint({name: "mullionFaceExtension", graphic: this.graphic, staticX: 0, staticY: 0});

        const g = this.lines;
        g.lineStyle(STROKE_WIDTH, lineBlueHeavy, 1);
        g.moveTo(points[0].x, points[0].y);
        for(const p of points.slice(1)) g.lineTo(p.x, p.y);
    }
}
